export class SettingConfig {
    public static isMobile: boolean = false;
}